import type { Image, Video } from '~/utils/crystallize/component-schemas'
import type { CtaData } from '~/utils/crystallize/pieces'

const ILLUSTRATION_KEYS = ['justitia', 'icon-man-warning', 'icon-man-check', 'judge']

export type IllustrationKey = typeof ILLUSTRATION_KEYS[number]

/**
 * Resolve the first CTA action that contains a link
 *
 * @param cta - Raw CTA data from Crystallize
 */
export function getCtaAction(cta: CtaData | null | undefined) {
  return cta?.action?.find((it): it is { link: string, label?: string | null } => !!it.link) || null
}

/**
 * Resolve props for Crystallize CTA pieces.
 *
 * TODO: See if this can be a transform on the schema.
 *
 * @param cta - Raw CTA data from Crystallize
 */
export function getCtaProps(cta: CtaData | null | undefined) {
  let illustration: IllustrationKey | null = null
  let image: Image | null = null
  let video: Video | null = null

  if (Array.isArray(cta?.graphic)) {
    illustration = cta.graphic.find((it): it is { key: string, value: IllustrationKey } => ILLUSTRATION_KEYS.includes(it.value as IllustrationKey))?.value ?? null
  }
  else if (cta?.graphic && 'firstImage' in cta.graphic) {
    image = cta.graphic.firstImage ?? null
  }
  else if (cta?.graphic && 'firstVideo' in cta.graphic) {
    video = cta.graphic.firstVideo ?? null
  }

  return {
    action: getCtaAction(cta),
    title: cta?.title,
    text: cta?.text,
    illustration,
    image,
    video,
  }
}
